export default "__VITE_ASSET__bd22b009__"